import { LocalStorageKeys, useLocalStorage } from "./useLocalStorage";
import {jwtDecode} from "jwt-decode";

export function useDecodeJWT(): any {
  const [user] = useLocalStorage(LocalStorageKeys.user, null, false);
  return jwtDecode(user.accessToken);
}
